export enum ClerkTypes {
  legalEntity = 90001,
  individual = 90002
}